import { OrangeText } from './styles'

const imagePath = '/images/cases/design-991/decorations/'

export const config = {
  title: 'design 991',
  description: (
    <>
      <OrangeText>Design 991</OrangeText> is an e-learning platform built for
      designers.
    </>
  ),
  headerImageDesktop: {
    src: `${imagePath}header-desktop.webp`,
    alt: 'desktop header image',
    fill: true,
  },
  headerImageMobile: {
    src: `${imagePath}header-mobile.webp`,
    alt: 'mobile header image',
    fill: true,
  },
  tags: ['UI/UX', 'Wireframes', 'App map', 'User flows'],
}
